module.exports = __webpack_public_path__ + "img/yellow.5de65147.png";